const Breakpoints = {};


Breakpoints.Mobile = "md";
Breakpoints.Tablet = "lg";
Breakpoints.Computer = "xl";

module.exports = Breakpoints;